import { useEffect } from 'react'

import { useRouter } from 'next/router'

import { useSessionQueryState } from '@/api'
import { LOGIN_STATUS } from '@/features/user/userSlice'

import { useModalContext } from '../contexts/ModalContext'
import { useAppSelector } from './useAppSelector'

export const useAuthenticatedOnly = ({
  redirectPath = '/',
  isLoading,
  login,
  skip,
  promptCustomTitle,
}: {
  redirectPath?: string
  isLoading?: boolean
  login?: boolean
  skip?: boolean
  promptCustomTitle?: string
}) => {
  const { push } = useRouter()
  const isLoggedIn = useAppSelector((state) => state.user.loginStatus === LOGIN_STATUS.LOGGED_IN)
  const { isFetching } = useSessionQueryState()
  const { openModal, closeModal, modalType } = useModalContext()

  useEffect(() => {
    if (skip) {
      return
    }
    if (isLoading || isFetching) {
      return
    }
    if (!isLoggedIn && !login) {
      // Do shallow redirect if its possible
      push(redirectPath)
    }
    if (!isLoggedIn && login) {
      const onClose = () => {
        closeModal()
        push(redirectPath)
      }
      openModal({ type: 'LOGIN', props: { customTitle: promptCustomTitle, onClose } } as const)
    }
  }, [isLoggedIn, isLoading, redirectPath, skip, login, promptCustomTitle, isFetching, push, openModal, closeModal])

  return { isLoggedIn, isPromptingLogin: modalType === 'LOGIN' }
}
